import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/common/Elements/Elements';

import classes from './Progress.module.scss';

const Progress = ({ progress, preText, percent = true }) => {
  return (
    <Text className={classes.box}>
      <Text size={2}>{preText && `${preText} - `}</Text>
      <Text className={classes.progress} weight="b">
        {progress}
        {percent && '%'}
      </Text>
    </Text>
  );
};

Progress.propTypes = {
  progress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  preText: PropTypes.string,
  percent: PropTypes.bool
};

export default Progress;
